module.exports = require("babel-runtime/core-js/json/stringify");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/json/stringify"
// module id = 10
// module chunks = 0